export default __webpack_public_path__ + "static/media/note.8fcfe104.png";